<template>
  <el-dialog
    :title="$t('chainProduct.deleteProduct')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <span>{{ $t('chainProduct.confirmDelete') }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="danger" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteChainProduct } from '@/api/admin/chainProduct/chainProductApi'

export default {
  name: 'DeleteProduct',
  data() {
    return {
      dialogVisible: false,
      currentProduct: null
    }
  },
  methods: {
    open(product) {
      this.currentProduct = product
      this.dialogVisible = true
    },
    async handleConfirm() {
      try {
        await deleteChainProduct({ productId: this.currentProduct.productId })
        this.$message.success(this.$t('common.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('Delete product failed:', error)
      }
    }
  }
}
</script>